import {
  PRESETS,
  type PresetKey,
  type DateRange,
  rangeForPreset,
  detectRangePreset,
  asOfForPreset,
  detectAsOfPreset,
} from '../../lib/dateRanges';

function PresetSelect({
  value,
  onPick,
}: {
  value: PresetKey;
  onPick: (key: PresetKey) => void;
}) {
  return (
    <label style={{ fontSize: 13 }}>
      Period{' '}
      <select value={value} onChange={(e) => onPick(e.target.value as PresetKey)}>
        {PRESETS.map((p) => (
          <option key={p.key} value={p.key}>
            {p.label}
          </option>
        ))}
      </select>
    </label>
  );
}

/** Preset dropdown + From/To date inputs for date-range reports. */
export function DateRangePicker({
  from,
  to,
  onChange,
}: {
  from: string;
  to: string;
  onChange: (range: DateRange) => void;
}) {
  const preset = detectRangePreset(from, to);
  return (
    <>
      <PresetSelect
        value={preset}
        onPick={(key) => {
          const r = rangeForPreset(key);
          if (r) onChange(r);
        }}
      />
      <label style={{ fontSize: 13 }}>
        From <input type="date" value={from} onChange={(e) => onChange({ from: e.target.value, to })} />
      </label>
      <label style={{ fontSize: 13 }}>
        To <input type="date" value={to} onChange={(e) => onChange({ from, to: e.target.value })} />
      </label>
    </>
  );
}

/** Preset dropdown + a single As-of date input for cumulative reports. */
export function AsOfPicker({
  asOf,
  onChange,
}: {
  asOf: string;
  onChange: (asOf: string) => void;
}) {
  const preset = detectAsOfPreset(asOf);
  return (
    <>
      <PresetSelect
        value={preset}
        onPick={(key) => {
          const v = asOfForPreset(key);
          if (v) onChange(v);
        }}
      />
      <label style={{ fontSize: 13 }}>
        As of <input type="date" value={asOf} onChange={(e) => onChange(e.target.value)} />
      </label>
    </>
  );
}
